import { useMutation } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import toast from 'react-hot-toast';
import { profileApi, queryClient, subscriptionApi } from '~/lib/request';

type CreateSubscriptionResponse =
  | {
      payment_url: string;
    }
  | {
      id: string;
      plan_id: string;
      start_date: string;
      end_date: string;
      is_active: boolean;
      is_renewable: boolean;
    };

type CreateSubscriptionError = {
  detail?: string;
};

function useUpdateSubscription() {
  const result = useMutation({
    mutationFn: async (planId: string) => {
      const result = await subscriptionApi
        .post('api/subscriptions/create', {
          json: {
            plan_id: planId,
            discount: 0,
            redirectUrl: `${window.location.origin}/subscription`,
          },
        })
        .json<CreateSubscriptionResponse>();

      try {
        await profileApi.get('api/profile/me?bypass_cache=true').json();
      } catch (error) {
        console.error('Failed to refresh user cache', error);
      }

      return result;
    },

    onSuccess: (data) => {
      if ('payment_url' in data) {
        window.location.href = data.payment_url;

        return;
      }

      queryClient.invalidateQueries({ queryKey: ['balance'] });
      queryClient.invalidateQueries({ queryKey: ['activeSubscription'] });

      toast.success('New subscription created');
    },
    onError: async (error) => {
      console.log(error);

      let errorDetail = 'Please try again later';

      if (error instanceof HTTPError) {
        const errorData = error.data as CreateSubscriptionError;
        errorDetail = errorData?.detail || '';
      }

      toast.error(errorDetail);
    },
  });

  return result;
}

export default useUpdateSubscription;
